// https://vuex.vuejs.org/en/mutations.html

export default {
  auth_request (state) {
    state.authStatus = 'loading'
  },
  auth_success (state, { user }) {
    state.authStatus = 'success'
    state.user = user
    state.userInfo = user
  },
  auth_error (state) {
    state.authStatus = 'error'
  },
  logout (state) {
    state.authStatus = ''
    state.userInfo = ''
  },
  setTableList (state, tableList) {
    state.tableList = tableList
  }
}
